'use client'

export const isOnServer = typeof window === 'undefined'

export type TPlatform = 'ios' | 'android' | 'other'

export const getPlatform = (): TPlatform => {
	if (typeof navigator === 'undefined') {
		return 'other'
	}

	const userAgent =
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		navigator.userAgent || navigator.vendor || (window as any).opera

	if (/android/i.test(userAgent)) {
		return 'android'
	}

	// iOS (iPhone/iPad simulators, new iPads without "iPad" in UA, etc)
	if (
		/iPad|iPhone|iPod/.test(userAgent) ||
		(navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
	) {
		return 'ios'
	}

	return 'other'
}
